import { Nullable } from "@/general/custom-types/CustomTypes";

export function notNullOrUndefined(value: any): boolean {
  return value != null && value !== undefined;
}

export function notNullOrUndefinedOrBlank(value: any): boolean {
  const result: boolean = value != null && value !== undefined && value !== "";
  return result;
}

export function dbg(obj: Record<string, unknown>): void {
  alert(JSON.stringify(obj));
}

export function formatJson(
  json: Nullable<string>,
  replacer: ((this: any, key: string, value: any) => any) | null = null,
  space: string | number = 1
): string {
  return notNullOrUndefined(json) ? JSON.stringify(JSON.parse(<string>json), null, space) : "";
}
